import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { ColumnInfo, OpDashboardControl } from "../models/custom"
import { OpAlarmEvent } from "../models/dw"

import { DashboardComponent } from "../helpers/dashboard-component"
import { OpAlarmDef } from "../models/core";

export class DataProviderAlarmDef {

    // #region Ctor

    constructor(private dataProvider: DataProvider) { }

    // #endregion


    // #region Public Methods

    public getAlarmDef = (referenceType: Enums.ReferenceType, referenceValue: number): JQueryPromise<OpAlarmDef[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetAlarmDef', { referenceType: referenceType, referenceValue: referenceValue }, 'OpxGetAlarmDefResult')
            .then((data: any[]) => {
                const result: OpAlarmDef[] = DataProvider.convertArrayResult<OpAlarmDef>(data, OpAlarmDef)

                OpAlarmDef.loadNavigationProperties(this.dataProvider, result)

                return result
            })
    }

    // #endregion
}